/* unplugin-vue-components disabled */import script from "./organ-add.vue?vue&type=script&setup=true&lang=ts"
export * from "./organ-add.vue?vue&type=script&setup=true&lang=ts"

import "./organ-add.vue?vue&type=style&index=0&id=41bfa3d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41bfa3d0"]])

export default __exports__